import { getFirebase } from '@/services/firebaseApp'
import { userHasSocialLogin } from '@/features/Auth/identity/userHasSocialLogin'
import type { Profile } from '@/services/api/session/views'

export async function isEmailVerified(data: Profile) {
  const firebase = await getFirebase()
  const firebaseUser = firebase.auth().currentUser
  const { hasSocialLogin } = await userHasSocialLogin()

  if (hasSocialLogin) return true
  if (!firebaseUser || !data) return false
  if (data?.id !== firebaseUser.uid) return false

  return firebaseUser.emailVerified
}

/**
 * E-mail verification is not currently a gate — this returns immediately.
 *
 * The topic it used to wait on is gone: nothing awaited it (the wait was commented out with
 * the rest of this body) while two screens still published into it. If the gate comes back,
 * it should await the profile the way `ensureProfileDetails` does rather than require a
 * screen to announce. See EPIC-005.
 */
export async function ensureEmailVerified(_profile?: Profile) {
  return true
}
